<template>
  <DialogLayout
    title="詳細検索"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
    class="detail-search-dialog"
  >
    <template #form>
      <FeesForPaidPassengersForm
        ref="feesForPaidPassengersForm"
        v-model="feesForPaidPassengersForm"
        label-width="10em"
        formMode="search"
        :autocomplete-airport-code-set="autocompleteAirportCodeSet"
        :autocomplete-customer-code-set="autocompleteCustomerCodeSet"
      />
    </template>
    <template #footer>
      <SearchDialogFooter
        @clear="clickClear"
        @search="clickSearch"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import FeesForPaidPassengersForm from '@/components/organisms/dialog/calculation/FeesForPaidPassengersForm.vue'
import SearchDialogFooter from '@/components/organisms/dialog/SearchDialogFooter.vue'

export default {
  components: {
    DialogLayout,
    FeesForPaidPassengersForm,
    SearchDialogFooter
  },
  props: {
    model: Object,
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    visible: Boolean
  },
  data () {
    return {
      feesForPaidPassengersForm: {
        billing_ym: this.getDefaultBillingYm(),
        bill_to_code: undefined,
        departure_airport_code: undefined,
        seats: undefined,
        paid_passengers: undefined,
        aircraft_weight_type: undefined,
        passenger_landing_fee_without_tax: undefined,
        passenger_landing_fee_tax: undefined,
        passenger_landing_fee_with_tax: undefined,
        passenger_landing_fee_before_exemption: undefined,
        tax: undefined,
        taxation: undefined,
        exemption_code: undefined,
        exemption_rate: undefined,
        unit_fee: undefined,
        // landingFeeBeforeExemption: undefined,
        manual_data_only: false,
        automatic_data_only: false
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (value) {
        this.$emit('update:visible', value)
      }
    }
  },
  mounted () {
    // console.log('RegistrationSymbolMasterDetailSearchDialog.mounted')
  },
  methods: {
    clickClear () {
      this.$refs.feesForPaidPassengersForm.clearFields()
    },
    clickSearch () {
      this.$refs.feesForPaidPassengersForm.validate()
        .then((valid) => {
          sessionStorage.setItem('feesForPaidPassengersSearchCond', JSON.stringify(this.feesForPaidPassengersForm))
          this.dialogVisible = false
          this.$emit('search', this.feesForPaidPassengersForm)
        })
    },
    open () {
      const searchCond = JSON.parse(sessionStorage.getItem('feesForPaidPassengersSearchCond'))
      this.$nextTick(() => {
        this.$refs.feesForPaidPassengersForm.clearFields()
        if (searchCond) {
          Object.keys(this.feesForPaidPassengersForm).forEach((x) => {
            this.$set(this.feesForPaidPassengersForm, x, searchCond[x])
          })
          if (!this.feesForPaidPassengersForm.manual_data_only) {
            this.feesForPaidPassengersForm.manual_data_only = false
          }
          if (!this.feesForPaidPassengersForm.automatic_data_only) {
            this.feesForPaidPassengersForm.automatic_data_only = false
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
